import { Component, OnInit, Renderer2, OnChanges, ViewChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';
declare var d3: any;

@Component({
  selector: 'app-production',
  templateUrl: './production.component.html',
  styleUrls: ['./production.component.css']
})
export class ProductionComponent implements OnInit {
  @Input() labels: any;
  @ViewChild('chart') private chartContainer: ElementRef;
  data: any = {
    "7-days": 0,
    "last-year": 0,
    "current": 0,
    "units": ["","",""]
  };
  dayproduction: Array<any>;

  private margin: any = { top: 40, bottom: 80, left: 40, right: 40 };
  private chart: any;
  private width: number;
  private height: number;
  private xScale: any;
  private yScale: any;
  private colors: any;
  private xAxis: any;
  private yAxis: any;

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
  }
  onUpdate(data: any, units: string[]) {
    this.data = data;
    this.data.units = units;
    this.dayproduction = data.dayproduction;
    
    setTimeout(() => {
      this.createChart();
    });

  }
  createChart() {
    if(this.chartContainer.nativeElement.children.length > 0){
      let _t = this.chartContainer.nativeElement.children[0];
      _t.remove();
    }
    const element = this.chartContainer.nativeElement;

    let start = new Date().setHours(0, 0, 0, 0);
    let end = new Date().setHours(24, 0, 0, 0);
    var production = [];
    //Add midnight manually
    production.push({
      timestamp: start,
      value: 0
    });
    for (var i = 0; i<this.dayproduction.length; i++){
      if(this.dayproduction[i].timestamp>=start){
        production.push(this.dayproduction[i]);
      }
    }

    var margin = { top: 20, right: 20, bottom: 30, left: 50 },
      width = element.offsetWidth - margin.left - margin.right,
      height = element.offsetHeight - margin.top - margin.bottom;


    const xDomain = [start, end];
    const yDomain = [0, d3.max(production, d => d.value)];
    var x = d3.scaleLinear().domain(xDomain).range([0, width]);
    var y = d3.scaleLinear().domain(yDomain).range([height, 0]);

    // define the line
    var valueline = d3.line()
      .x(function (d) { return x(d.timestamp); })
      .y(function (d) { return y(d.value);});

    var svg = d3.select(element).append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform",
      "translate(" + margin.left + "," + margin.top + ")");
    
    this.xScale = d3.scaleTime().domain(xDomain).range([0, width]);
    this.yScale = d3.scaleLinear().domain(yDomain).range([height, 0]);
    
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .attr("class", "axis")
      .style("font-size", "14px")
      .call(
      d3.axisBottom(this.xScale).ticks(7).tickFormat(d3.timeFormat("%H:%M"))
    )

    svg.append("g")
      .attr("class", "axis")
      .style("font-size", "14px")
      .call(
        d3.axisLeft(this.yScale).ticks(5)
      );

    svg.append("path")
      .attr("class", "line")
      .style("stroke", "#BE0000")
      .style("fill", "none")
      .style("stroke-width", 3)
      .style("stroke-linecap", "round")
      .attr("d", valueline(production));
    
    svg.append("text")
      .attr("x", -10)
      .style("font-size", "14px")
      .attr("y", -10)
      .style("text-anchor", "end")
      .text(this.data.units[0]);
  }
}



// WEBPACK FOOTER //
// ./src/app/chart/production/production.component.ts